// @ts-nocheck
export const localeCodes =  [
  "en",
  "fr-CA"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_661b6c44",
      load: () => import("#nuxt-i18n/661b6c44" /* webpackChunkName: "locale_en_46json_661b6c44" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_4e935a20",
      load: () => import("#nuxt-i18n/4e935a20" /* webpackChunkName: "locale_fr_45CA_46json_4e935a20" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/949ed66c" /* webpackChunkName: "config_i18n_46config_46ts_949ed66c" */)
]
export const normalizedLocales = [
  {
    code: "en",
    dir: "ltr",
    language: undefined
  },
  {
    code: "fr-CA",
    dir: "ltr",
    language: undefined
  }
]
/** client **/

/** client-end **/